import classnames from 'classnames';
import propTypes from 'prop-types';
import React from 'react';

const classes = ({success}) => classnames({
	'Button--success': success
});

const Button = ({children, success, ...props}) => (
	<button className={classes({success})} {...props} type='button'>
		{children}
		<style jsx>
			{`
				.Button--success {
					background-color: green;
				}
			`}
		</style>
	</button>
);

Button.propTypes = {
	children: propTypes.any,
	success: propTypes.bool
};

export default Button;



// WEBPACK FOOTER //
// components/button.js